import React, { useEffect, useState } from "react";
import "./style.css";
import freightService from "../../service/freight.service";
import { translatorForTheStatusOfStoppingPoints } from "../../view/frete-copy/action/action";
import { corDoStatus } from "../MapaRota/cores";

function paraMillis(valor) {
  if (valor == null) return null;
  if (typeof valor === "number") return Number.isFinite(valor) ? valor : null;
  if (typeof valor.toMillis === "function") return valor.toMillis();
  if (typeof valor.seconds === "number") {
    return valor.seconds * 1000 + Math.floor((valor.nanoseconds || 0) / 1e6);
  }
  const d = new Date(valor).getTime();
  return Number.isNaN(d) ? null : d;
}

function dataHora(ms) {
  return ms ? new Date(ms).toLocaleString("pt-BR") : "";
}

function duracao(inicio, fim) {
  if (!inicio || !fim) return "–";
  const minutos = Math.max(0, Math.round((fim - inicio) / 60000));
  if (minutos < 60) return `${minutos}min`;
  return `${Math.floor(minutos / 60)}h${String(minutos % 60).padStart(2, "0")}min`;
}

function rotulo(status) {
  const traduzido = translatorForTheStatusOfStoppingPoints(status);
  return Array.isArray(traduzido) ? String(status || "Etapa") : traduzido;
}

/**
 * Linha do tempo de status com hora do servidor. Sai da subcoleção `events`, que é o que a Etapa 5
 * grava — e é a mesma medida que alimenta o relatório de tempo de espera.
 */
function LinhaDoTempoFrete({ frete, compacta = false }) {
  const [eventos, setEventos] = useState([]);
  const [carregando, setCarregando] = useState(false);

  useEffect(() => {
    if (!frete?.id) {
      setEventos([]);
      return undefined;
    }

    setCarregando(true);
    const cancelar = freightService.subscribeEventsByFreight(
      frete.id,
      (snap) => {
        setEventos(snap.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
        setCarregando(false);
      },
      (erro) => {
        setEventos([]);
        setCarregando(false);
        console.error("Erro ao carregar a linha do tempo do frete:", erro);
      },
    );

    return () => cancelar && cancelar();
  }, [frete?.id]);

  if (carregando && !eventos.length) {
    return <p className="linha-tempo__vazio">Carregando etapas...</p>;
  }

  if (!eventos.length) {
    return (
      <p className="linha-tempo__vazio">
        Sem etapas registradas com hora do servidor. A linha do tempo passa a
        existir quando o aplicativo novo estiver publicado.
      </p>
    );
  }

  return (
    <ol
      className={compacta ? "linha-tempo linha-tempo--compacta" : "linha-tempo"}
    >
      {eventos.map((evento, indice) => {
        const quando = paraMillis(evento.occurredAt);
        const seguinte = paraMillis(eventos[indice + 1]?.occurredAt);
        const cor = corDoStatus(evento.status);
        // Cheia quando a etapa já fechou, vazada na que ainda está correndo. É o que a referência
        // faz e é o que o operador precisa distinguir de relance.
        const encerrada = Boolean(seguinte);

        return (
          <li key={evento.id} className="linha-tempo__etapa">
            <span
              className="linha-tempo__bolinha"
              style={{
                borderColor: cor,
                background: encerrada ? cor : "transparent",
              }}
            />
            <div className="linha-tempo__texto">
              <strong>{rotulo(evento.status)}</strong>
              <small>{dataHora(quando)}</small>
            </div>
            <span className="linha-tempo__duracao">
              {duracao(quando, seguinte)}
            </span>
          </li>
        );
      })}
    </ol>
  );
}

export default LinhaDoTempoFrete;
